module.exports = __webpack_public_path__ + "img/icon_candy_green.c7ddaeb6.svg";